import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NationalUserComponent } from './national-user.component';
import { NationalUserListComponent } from './national-user-list/national-user-list.component';
import { NationalUserDetailComponent } from './national-user-detail/national-user-detail.component';
import { MyDetailsComponent } from './my-details/my-details..component';
import { MembersSetAsActive } from './members-set-as-active/members-set-as-active.component';

const routes: Routes = [
  {
    path: '', component: NationalUserComponent, children: [
      {
        path: 'my-details', component: MyDetailsComponent
      },
      {
        path: 'set-as-active', component: MembersSetAsActive
      },
      {
        path: '', component: NationalUserListComponent
      },
      {
        path: ':id', component: NationalUserDetailComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NationalUserRoutingModule { }
